import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import Immutable from 'immutable';
import debounce from 'lodash/debounce';
import { connect } from 'react-redux';
import { fillDetails } from '../../models/profile';
import * as actions from '../../actions';

import NotFoundPage from '../NotFoundPage';

import numberFormat from '../../utils/numberFormat';
import getImageUrl from '../../utils/getImageUrl';

import RecommendedCouponsView from './recommendeds'
import ReceivedCouponsView from './receiveds'

import queryString from 'query-string';

export class MorePage extends Component {
  constructor(props) {
    super(props);

    this.handleTabRecommend = this.handleTabRecommend.bind(this);
    this.handleTabReceived = this.handleTabReceived.bind(this);

    let tab = 'recommendeds';
    if (this.props.location.search) {
      const params = queryString.parse(this.props.location.search);
      if (params.tab === "2") {
        tab = 'receiveds';
      }
    }

    this.state = {
      tab
    };
  }

  componentDidMount() {
    try {
      if (window.performance.navigation.type === 1) {
        setTimeout(function () {
          window.scrollTo(0, 0);
        }, 500);
      }
    } catch(ignore) {
      // window.performance.navigation 가 없을 수 있음
    }
  }

  handleTabRecommend() {
    this.setState({
      tab: 'recommendeds'
    });
  }

  handleTabReceived() {
    this.setState({
      tab: 'receiveds'
    });
  }

  render() {
    const { device, showModal, entities } = this.props;
    const { tab } = this.state;

    const { coupons, received } = entities;
    const type = tab;

    return (
      <div id="kakaoWrap">
        <div id="kakaoContent" className="cont_coupon">
          <ul className="tab_coupon">
            <li className={type === 'recommendeds' ? 'on' : 'off'}>
              <button className="link_tab" onClick={this.handleTabRecommend}>
                추천 쿠폰
              </button>
            </li>
            <li className={type === 'receiveds' ? 'on' : 'off'}>
              <button className="link_tab" onClick={this.handleTabReceived}>
                받은 쿠폰
              </button>
            </li>
          </ul>
          {
            type === "recommendeds" ? (
            <RecommendedCouponsView type={type}
              coupons={coupons}
            />) : (
            <ReceivedCouponsView type={type}
              receivedCoupons={[]}
            />
            )
          }
        </div>
        <div id="kakaoFoot" className="foot_coupon">
          <span className="ico_coupon">카카오톡 채널</span>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, {}) => {
  const { device, entities } = state;
  return { device, entities };
};

export default connect(
  mapStateToProps,
  (dispatch) => bindActionCreators({
    showModal: actions.showModal
  }, dispatch)
)(MorePage);



// WEBPACK FOOTER //
// ./src/containers/MorePage/index.js